import { Alert } from "@omni/ui/components/Alert/alert.component";
import { useEffect } from "react";

import ResultField from "@/components/Calculator/Components/ResultField/resultField.component";
import ResultTitle from "@/components/Calculator/Components/ResultTitle/resultTitle.component";
import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import * as CalculatorStepTracker from "@/services/tracking/trackers/tools/calculators/calculatorStep.tracker";
import { CALCULATOR_KEYS } from "@/services/tracking/trackers/tools/calculators/config";

import { CorrugatedSheetShoppingList } from "../corrugatedSheetCalculator.types";

type ResultComponentProps = {
    result: CorrugatedSheetShoppingList;
    mailParams: Record<string, string>;
};

const ResultComponent = ({ result, mailParams }: ResultComponentProps) => {
    const { t } = useGranite();
    const { surface, slope, hasSlopeWarning, productLine } = result;

    useEffect(() => {
        CalculatorStepTracker.trackSubmit(CALCULATOR_KEYS.corrugateSheet);
    }, []);

    if (hasSlopeWarning) {
        return (
            <div id="result">
                <ResultTitle
                    displayMailButton={false}
                    displayPrintButton={false}
                />
                <Alert
                    color="danger"
                    fade={false}
                    closeAriaLabel={t("general.alert.close")}
                >
                    {t(
                        "calculator.corrugatedSheetCalculator.roofSlope.warning"
                    )}
                </Alert>
            </div>
        );
    }

    return (
        <div id="result">
            <ResultTitle mailParams={mailParams} />
            {productLine && (
                <Row>
                    <Col>
                        <h3>
                            {t(
                                `calculator.corrugatedSheetCalculator.productLineTitle.${productLine}`
                            )}
                        </h3>
                    </Col>
                </Row>
            )}
            <Row>
                <ResultField
                    sm={12}
                    md={8}
                    lg={6}
                    copy={t("calculator.corrugatedSheetCalculator.roofSurface")}
                    unit={"m"}
                    sup={2}
                    value={(surface / 10_000).toFixed(3)}
                />
                <ResultField
                    sm={12}
                    md={8}
                    lg={6}
                    copy={t("calculator.corrugatedSheetCalculator.roofSlope")}
                    unit={"%"}
                    value={slope.toFixed(2)}
                />
            </Row>
        </div>
    );
};

export default ResultComponent;
